import { faHome } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import { paths } from '../../routing/path';
import { USER_ROLES } from '../../utils/constants';

interface HomeButtonProps {
    onClick?: () => void;
}

export const HomeButton = (props: HomeButtonProps) => {
    const summary = JSON.parse(localStorage.getItem('loggedInUserSummary'));
    const isAdmin = summary?.roleId === USER_ROLES.ADMIN;
    const linkRoute = isAdmin ? paths.account.dashboard : paths.account.venuesHome;

    return (
        <span>
            <Link to={linkRoute} onClick={() => props.onClick?.()}>
                <FontAwesomeIcon icon={faHome} />
            </Link>
        </span>
    );
};
